import { createPublicClient, fallback, http } from 'viem';
import { defineChain } from 'viem/utils';

const hyperEvm = defineChain({
    id: 999,
    name: 'HyperEVM',
    nativeCurrency: { name: 'HYPE', symbol: 'HYPE', decimals: 18 },
    rpcUrls: {
        default: { http: ['https://rpc.hyperliquid.xyz/evm'] },
    },
});

export const HYPER_EVM_PUBLIC_RPC_URLS = [
    'https://rpc.hyperliquid.xyz/evm',
    'https://hyperliquid.drpc.org',
    'https://rpc.nodeflare.app/hl/public',
    'https://hyperliquid-json-rpc.stakely.io',
] as const;

// Per-RPC budget before we give up and try the NEXT provider. A healthy HyperEVM RPC answers
// an eth_call in ~300ms, so 2s is already generous; the old 5s meant a single slow or
// rate-limited provider stalled the whole read for five seconds before failing over.
const RPC_TIMEOUT_MS = 1_500;

export const hyperEvmPublicClient = createPublicClient({
    chain: hyperEvm,
    transport: fallback(
        // retryCount 0 is deliberate. viem's http transport retries 3x by DEFAULT, which
        // stacks on top of the timeout (4 attempts x 5s on one bad provider) — and retrying
        // a provider that just rate-limited us is the least useful thing we can do. With
        // four providers in the list, moving to the next one IS the retry, and it is both
        // faster and more likely to succeed.
        HYPER_EVM_PUBLIC_RPC_URLS.map(url =>
            http(url, { timeout: RPC_TIMEOUT_MS, retryCount: 0 }),
        ),
        { rank: false },
    ),
});
